module.exports = __webpack_public_path__ + "9f3834bcc23e9147663fa05fcf259d0e.pdf";